import {
  pricingTranslationsEs,
  featuresSectionEs,
  footerExtendedEs,
  organizationsEs,
  b2bContactEs,
  signInEs,
  a11yEs,
} from './marketingCopy.es'
import { accountAdminCopyEs } from './accountAdminCopy/accountAdminCopy.es'

export const es = {
  hero: {
    title: 'Zporti',
    subtitle: 'Desafía a tus Amigos. Predice el Juego. Gana Juntos.',
    description:
      'Crea desafíos de predicciones deportivas con amigos, rastrea tus victorias y compite en la tabla de clasificación. La plataforma definitiva para la competencia amistosa y las predicciones deportivas.',
  },
  siteNav: {
    home: 'Inicio',
    organizations: 'Organizaciones',
    contact: 'Contacto',
    packs: 'Precios',
    signIn: 'Iniciar sesión',
    createAccount: 'Registrarse',
    openApp: 'Abrir app',
    signedInAs: 'Sesión como',
    signedInNameFallback: 'Tu cuenta',
    signOut: 'Cerrar sesión',
    signOutConfirmTitle: '¿Cerrar sesión?',
    signOutConfirmMessage: 'Tendrás que iniciar sesión de nuevo para acceder a tu cuenta.',
    signOutConfirm: 'Cerrar sesión',
    signOutCancel: 'Cancelar',
    signOutErrorTitle: 'Error',
    signOutError: 'No se pudo cerrar sesión. Inténtalo de nuevo.',
  },
  features: {
    title: '¿Por qué Zporti?',
    subtitle: 'Todo lo que necesitas para convertir las predicciones deportivas en competencia amistosa',
    challenge: {
      title: 'Desafía a Amigos',
      description:
        'Crea desafíos de predicción personalizados e invita a tus amigos a competir. Configura desafíos grupales o compite uno contra uno con amigos individuales.',
    },
    track: {
      title: 'Rastrea Resultados',
      description:
        'Ve puntajes en tiempo real, rastrea tus predicciones y monitorea tu tasa de victorias. Recibe notificaciones instantáneas cuando lleguen los resultados del juego.',
    },
    compete: {
      title: 'Compite y Gana',
      description:
        'Escala la tabla de clasificación, gana derechos de presumir y ve quién es el mejor predictor. Celebra victorias y rastrea tu progreso con el tiempo.',
    },
    groups: {
      title: 'Grupos y temporadas',
      description:
        'Mantén al mismo grupo de amigos semana tras semana, compara posiciones en el grupo y crea retos con sabor a liga—no solo un partido suelto.',
    },
    locks: {
      title: 'Pronósticos al silbatazo',
      description:
        'Los pronósticos se cierran al inicio del partido: mismas reglas para todos. Los resultados se liquidan con el marcador oficial—justo y sin discusiones.',
    },
    organizations: {
      title: 'Organizaciones y marca',
      description:
        'Clubes, empresas y partners pueden usar sus colores, logos y plazas de miembros—tu comunidad se ve como tú dentro de la app.',
    },
    avatars: featuresSectionEs.avatars,
  },
  featuresSection: featuresSectionEs,
  howItWorks: {
    title: 'Cómo Funciona',
    subtitle: 'Comienza en tres pasos simples',
    step1: {
      title: 'Crea un Desafío',
      description: 'Elige un juego, establece tus predicciones e invita a amigos a unirse a tu desafío.',
    },
    step2: {
      title: 'Haz Predicciones',
      description:
        'Cada participante hace sus predicciones antes de que comience el juego. Bloquea tus selecciones y espera la acción.',
    },
    step3: {
      title: 'Ve Quién Gana',
      description:
        'Los resultados se calculan automáticamente cuando terminan los juegos. Celebra victorias y escala la tabla de clasificación.',
    },
  },
  competition: {
    title: 'Competencia Amistosa, Emoción Real',
    description:
      'Experimenta la emoción de las predicciones deportivas con tus amigos. Ya seas un fan casual o un entusiasta de las estadísticas, Zporti hace que cada juego sea más emocionante. Desafía a tus amigos, demuestra tus habilidades de predicción y ve quién sale ganador.',
  },
  stats: {
    challenges: 'Desafíos Activos',
    users: 'Usuarios Activos',
    predictions: 'Predicciones Realizadas',
    games: 'Juegos Rastreados',
  },
  benefits: {
    title: '¿Por qué Elegir Zporti?',
    subtitle: 'Todo lo que necesitas para la experiencia definitiva de predicciones deportivas',
    realTime: {
      title: 'Actualizaciones en Tiempo Real',
      description:
        'Recibe notificaciones instantáneas cuando comienzan los juegos, se actualizan los puntajes y llegan los resultados. Nunca te pierdas un momento con seguimiento de puntajes en vivo y cálculos automáticos de resultados.',
    },
    social: {
      title: 'Social y Conectado',
      description:
        'Conéctate con amigos vía Gmail, invítalos fácilmente y construye tu red de predicciones. Crea desafíos grupales o compite uno contra uno con tus amigos más cercanos.',
    },
    smart: {
      title: 'Predicciones Inteligentes',
      description:
        'Rastrea las probabilidades, analiza datos de partidos y haz predicciones informadas. Ve el rendimiento histórico, tasas de victoria y estadísticas detalladas para mejorar tus habilidades de predicción.',
    },
    fair: {
      title: 'Justo y Transparente',
      description:
        'Todos los resultados se calculan automáticamente cuando terminan los juegos. Sin disputas, sin puntuación manual, solo competencia justa y ganadores claros.',
    },
  },
  faq: {
    title: 'Preguntas Frecuentes',
    subtitle: 'Todo lo que necesitas saber sobre Zporti',
    q1: {
      question: '¿Cómo invito a amigos?',
      answer:
        'Puedes invitar amigos de dos maneras: conecta tu cuenta de Gmail para seleccionar contactos fácilmente, o ingresa direcciones de correo electrónico manualmente. Los amigos recibirán un enlace de invitación para unirse a tu desafío.',
    },
    q2: {
      question: '¿Cuándo se bloquean las predicciones?',
      answer:
        'Las predicciones deben hacerse antes de que comience el juego. Una vez que comienza un partido, todas las predicciones se bloquean y no se pueden cambiar. Esto asegura una competencia justa para todos.',
    },
    q3: {
      question: '¿Cómo se determinan los ganadores?',
      answer:
        'Los ganadores se calculan automáticamente cuando terminan los juegos. El sistema compara todas las predicciones con los resultados reales de los partidos y actualiza las tablas de clasificación en tiempo real.',
    },
    q4: {
      question: '¿Puedo crear desafíos grupales?',
      answer:
        '¡Sí! Puedes crear desafíos con múltiples amigos o competir uno contra uno con amigos individuales. Configura competencias grupales para ver quién tiene las mejores habilidades de predicción.',
    },
  },
  packsPage: {
    pageTitle: 'Planes y Precios',
  },
  contact: {
    title: 'Contacto',
    subtitle:
      'Dudas sobre el producto, comentarios, prensa o alianzas—escríbenos abajo o por correo. Leemos todos los mensajes.',
    emailLabel: 'Envíanos un correo a',
    email: 'info@zporti.com',
    form: {
      nameLabel: 'Nombre',
      emailLabel: 'Correo electrónico',
      messageLabel: 'Mensaje',
      submitButton: 'Enviar Mensaje',
      submitting: 'Enviando...',
      successMessage: '¡Gracias! Tu mensaje ha sido enviado. Te responderemos pronto.',
      errorMessage: 'Error al enviar el mensaje. Por favor, inténtalo de nuevo más tarde.',
      namePlaceholder: 'Nombre y apellido',
      emailPlaceholder: 'tu.correo@ejemplo.com',
      messagePlaceholder: 'Cuéntanos qué tienes en mente...',
      validation: {
        nameRequired: 'El nombre es obligatorio',
        nameTooLong: 'El nombre debe tener 50 caracteres o menos',
        emailRequired: 'El correo electrónico es obligatorio',
        emailInvalid: 'Por favor, introduce una dirección de correo electrónico válida',
        messageRequired: 'El mensaje es obligatorio',
        messageTooLong: 'El mensaje debe tener 500 caracteres o menos',
        invalidCharacters: 'Caracteres inválidos detectados. Por favor, elimina cualquier formato especial.',
      },
    },
  },
  footer: {
    title: '¿Listo para Empezar?',
    subtitle:
      'Únete a Zporti hoy y comienza a desafiar a tus amigos. Crea tu primer desafío de predicción en segundos.',
    privacyPolicy: 'Política de privacidad',
    termsOfService: 'Términos del servicio',
    dataDeletion: 'Eliminación de datos',
    credits: 'Créditos',
    privacyControls: 'Controles de privacidad',
    ...footerExtendedEs,
  },
  pricing: pricingTranslationsEs,
  organizations: organizationsEs,
  b2bContact: b2bContactEs,
  signIn: signInEs,
  a11y: a11yEs,
  accountAdmin: accountAdminCopyEs,
  legal: {
    backToHome: 'Volver al inicio',
    backToPrivacyAndData: 'Volver',
    privacyDocumentTitle: 'Política de privacidad',
    dataDeletionDocumentTitle: 'Instrucciones de eliminación de datos',
    termsDocumentTitle: 'Términos del servicio',
    creditsDocumentTitle: 'Créditos',
    aboutDocumentTitle: 'Sobre Zporti',
    supportDocumentTitle: 'Soporte',
    documentVersionLine: 'Última actualización {date} · versión {version}',
    privacyControlsCallout:
      '¿Necesitas cambiar consentimientos o solicitar una copia de tus datos? Abre los controles de privacidad en tu cuenta.',
    openPrivacyControls: 'Abrir controles de privacidad',
    signInForPrivacyControls: 'Inicia sesión para abrir los controles de privacidad',
  },
  privacyControls: {
    title: 'Controles de privacidad',
    subtitle: 'Administra el consentimiento de marketing y solicita una copia de los datos de tu cuenta.',
    marketingEmailsTitle: 'Correos de marketing',
    marketingEmailsHint: 'Puedes activar o retirar el consentimiento en cualquier momento.',
    analyticsTrackingTitle: 'Seguimiento analítico',
    analyticsTrackingHint: 'Activa o desactiva el seguimiento analítico para este dispositivo/navegador.',
    accountDataCopyTitle: 'Copia de los datos de la cuenta',
    accountDataCopyHint:
      'Descarga una copia en JSON de los datos personales vinculados a tu cuenta (disponible una vez cada 24 horas).',
    enabled: 'Activado',
    disabled: 'Desactivado',
    downloadMyData: 'Descargar mis datos',
    nextExportAvailable: 'Próxima exportación disponible',
    close: 'Cerrar',
    deleteYourAccount: 'Eliminar tu cuenta',
    deleteYourAccountHint:
      'Continúa para confirmar en la siguiente pantalla. Esto eliminará permanentemente tu cuenta y los datos relacionados.',
  },
}

